import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./Modal.css";

const Modal = ({ isOpen, onClose, children }) => {
  // Create a div for modal root dynamically
  const modalRoot = document.getElementById("modal-root") || (() => {
    const root = document.createElement("div");
    root.id = "modal-root";
    document.body.appendChild(root);
    return root;
  })();

  // Optional: prevent background scroll when modal open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay">
      <div className="modal-fullpage">
        <button className="close-btn" onClick={onClose}>✖</button>
        <div className="modal-content">{children}</div>
      </div>
    </div>,
    modalRoot
  );
};

export default Modal;
